import type {inferRouterInputs} from "@trpc/server";
import type {ZodFormattedError} from "zod";
import type {AppRouter} from "@app-trpc/server/api/trpc/[trpc]";

export type FindManyBlogArticlesDataInput = inferRouterInputs<AppRouter>['blog']['findMany'];
export type FindBlogArticleDataInput = inferRouterInputs<AppRouter>['blog']['findOne'];
export type CreateBlogArticleDataInput = inferRouterInputs<AppRouter>['blog']['createOne'];
export type UpdateBlogArticleDataInput = inferRouterInputs<AppRouter>['blog']['updateOne'];
export type DeleteBlogArticleDataInput = inferRouterInputs<AppRouter>['blog']['deleteOne'];

export const useNewsClient = () => {
  const client = useNuxtApp().$client;

  async function findPublished() {
    return client.blog.findPublished.query();
  }
  async function findTopPublished() {
    return client.blog.findTopPublished.query();
  }
  async function findMany(input: FindManyBlogArticlesDataInput) {
    return client.blog.findMany.query();
  }

  async function findOne(id: FindBlogArticleDataInput) {
    return client.blog.findOne.query(id);
  }

  async function create(data: CreateBlogArticleDataInput): Promise<{
    validationErrors: ZodFormattedError<CreateBlogArticleDataInput>
  } | undefined> {
    try {
      await client.blog.createOne.mutate(data);
    } catch (e) {
      if (isTRPCClientError(e)) { // TODO: simplify
        const zodError = e.data?.zodError as ZodFormattedError<CreateBlogArticleDataInput>;
        return {
          validationErrors: zodError
        }
      }
    }
  }

  async function updateOne(input: UpdateBlogArticleDataInput): Promise<{
    validationErrors: ZodFormattedError<UpdateBlogArticleDataInput>
  } | undefined> {
    try {
      await client.blog.updateOne.mutate(input);
    } catch (e) {
      if (isTRPCClientError(e)) { // TODO: simplify
        const zodError = e.data?.zodError as ZodFormattedError<UpdateBlogArticleDataInput>;
        return {
          validationErrors: zodError
        }
      }
    }
  }

  async function deleteOne(id: DeleteBlogArticleDataInput) {
    return client.blog.deleteOne.mutate(id);
  }


  return {
    findPublished,
    findTopPublished,
    findMany,
    findOne,
    create,
    updateOne,
    deleteOne,
  }
}